var _explanationLink, _mobileExplanationLin;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, object-curly-spacing, react/forbid-prop-types, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var _require = require("aphrodite"),
    StyleSheet = _require.StyleSheet,
    css = _require.css;

var React = require("react");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");
var PerseusApi = require("../perseus-api.jsx");
var Renderer = require("../renderer.jsx");
var mediaQueries = require("../styles/media-queries.js");
var styleConstants = require("../styles/constants.js");

var _require2 = require("../gorgon/proptypes.js"),
    linterContextProps = _require2.linterContextProps,
    linterContextDefault = _require2.linterContextDefault;

var defaultExplanationProps = {
    showPrompt: "Explain",
    hidePrompt: "Hide explanation",
    explanation: "explanation goes here\n\nmore explanation",
    widgets: {},
    linterContext: linterContextDefault
};

var Explanation = React.createClass({
    displayName: "Explanation",

    propTypes: _extends({}, Changeable.propTypes, {
        apiOptions: PerseusApi.Options.propTypes,
        explanation: React.PropTypes.string,
        hidePrompt: React.PropTypes.string,
        showPrompt: React.PropTypes.string,
        trackInteraction: React.PropTypes.func.isRequired,
        widgets: React.PropTypes.object,
        linterContext: linterContextProps
    }),

    getDefaultProps: function getDefaultProps() {
        return defaultExplanationProps;
    },

    getInitialState: function getInitialState() {
        return {
            expanded: false
        };
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    _onClick: function _onClick() {
        this.setState({
            expanded: !this.state.expanded
        });
        this.props.trackInteraction();
    },

    render: function render() {
        var Link = this.props.apiOptions.baseElements.Link;
        var _props$apiOptions = this.props.apiOptions,
            readOnly = _props$apiOptions.readOnly,
            isMobile = _props$apiOptions.isMobile;


        var linkAnchor = this.state.expanded ? this.props.hidePrompt : this.props.showPrompt;

        var linkContainer = void 0;

        var href = readOnly ? null : "javascript:void(0)";
        var onClick = readOnly ? null : this._onClick;

        if (isMobile) {
            linkContainer = React.createElement(
                "div",
                { className: css(styles.linkContainer) },
                React.createElement(
                    "a",
                    {
                        className: css(styles.mobileExplanationLink),
                        href: href,
                        onClick: onClick
                    },
                    linkAnchor
                ),
                this.state.expanded && React.createElement(
                    "svg",
                    { className: css(styles.disclosureArrow) },
                    React.createElement("polygon", {
                        style: { fill: backgroundColor },
                        points: "0," + arrowHeight + " " + (arrowWidth + "," + arrowHeight + " ") + (arrowWidth / 2 + ",0")
                    })
                )
            );
        } else {
            linkContainer = React.createElement(
                "div",
                { className: css(styles.linkContainer) },
                React.createElement(
                    Link,
                    {
                        className: css(styles.explanationLink),
                        href: href,
                        onClick: onClick
                    },
                    "[" + linkAnchor + "]"
                )
            );
        }

        var expandedStyle = isMobile ? styles.contentExpandedMobile : styles.contentExpanded;

        return React.createElement(
            "div",
            { className: css(styles.container) },
            linkContainer,
            React.createElement(
                "div",
                {
                    className: css(styles.content, isMobile && styles.contentMobile, this.state.expanded && expandedStyle),
                    style: {
                        height: this.state.expanded ? "auto" : 0,
                        overflow: this.state.expanded ? "visible" : "hidden"
                    },
                    ref: "content"
                },
                React.createElement(Renderer, {
                    apiOptions: this.props.apiOptions,
                    content: this.props.explanation,
                    widgets: this.props.widgets,
                    linterContext: this.props.linterContext
                })
            )
        );
    },

    getUserInput: function getUserInput() {
        return {};
    },

    simpleValidate: function simpleValidate(rubric) {
        return Explanation.validate(this.getUserInput(), rubric);
    }
});

var leftBorderSpacing = 23;
var verticalContentPadding = 10;

var arrowWidth = 30;
var arrowHeight = 14;
var backgroundColor = styleConstants.gray95;

var styles = StyleSheet.create({
    container: {
        display: "inline",
        position: "relative"
    },

    linkContainer: {
        display: "inline-block"
    },

    explanationLink: (_explanationLink = {
        fontStyle: "italic",
        color: "#007d96"

    }, _explanationLink[mediaQueries.xl] = {
        fontSize: 20,
        lineHeight: 1.1
    }, _explanationLink[mediaQueries.lgOrSmaller] = {
        fontSize: 17,
        lineHeight: 1.4
    }, _explanationLink[mediaQueries.smOrSmaller] = {
        fontSize: 14,
        lineHeight: 1.3
    }, _explanationLink),

    mobileExplanationLink: (_mobileExplanationLin = {
        color: styleConstants.kaGreen,
        borderBottom: "dashed 1px " + styleConstants.kaGreen,
        textDecoration: "none"

    }, _mobileExplanationLin[mediaQueries.xl] = {
        fontSize: 22,
        lineHeight: 1.4
    }, _mobileExplanationLin[mediaQueries.lgOrSmaller] = {
        fontSize: 20,
        lineHeight: 1.5
    }, _mobileExplanationLin[mediaQueries.smOrSmaller] = {
        fontSize: 18,
        lineHeight: 1.2
    }, _mobileExplanationLin),

    content: {
        position: "relative",
        transition: "margin-top 0.1s"
    },

    contentExpanded: {
        borderLeft: "5px solid #ccc",
        marginLeft: -leftBorderSpacing,
        paddingLeft: leftBorderSpacing,

        paddingBottom: verticalContentPadding,

        // Note: we still use arrow height as the vertical margin, even on
        // desktop when there is no arrow, but it's good enough.
        marginBottom: arrowHeight,
        marginTop: arrowHeight
    },

    contentExpandedMobile: {
        boxSizing: "content-box",
        paddingTop: 32,
        paddingBottom: 32,
        marginTop: arrowHeight
    },

    contentMobile: {
        background: backgroundColor,

        // TODO(benkomalo): this is to "full bleed" the background.
        // The actual content padding differs depending on the host
        // container, so this needs to be fixed eventually.
        marginLeft: styleConstants.negativePhoneMargin,
        marginRight: styleConstants.negativePhoneMargin,
        paddingLeft: styleConstants.phoneMargin,
        paddingRight: styleConstants.phoneMargin
    },

    disclosureArrow: {
        // HACK - positioning at "bottom: 0", doesn't actually position it to
        // the real bottom, because the container is `inline-block`, and it
        // seems to position it to the baseline? We put in a generous
        // fudge factor to position it down to be flush with the content box
        // below it.
        bottom: -(arrowHeight + 5),
        height: arrowHeight,
        left: "50%",
        marginLeft: -(arrowWidth / 2),
        position: "absolute",
        width: arrowWidth
    }
});

_.extend(Explanation, {
    validate: function validate(state, rubric) {
        return {
            type: "points",
            earned: 0,
            total: 0,
            message: null
        };
    }
});

module.exports = {
    name: "explanation",
    displayName: "Explanation",
    defaultAlignment: "inline",
    widget: Explanation,
    transform: _.identity,
    isLintable: true
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/explanation.jsx
 ** module id = 100
 ** module chunks = 0 1
 **/